"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comma = void 0;
function comma(source, length) {
    if (length === void 0) { length = 3; }
    var arr = String(source).split('.');
    arr[0] = arr[0].replace(new RegExp('(\\d)(?=(\\d{' + length + '})+$)', 'ig'), '$1,');
    return arr.join('.');
}
exports.comma = comma;
